Promise.all([import('scripts/marmalade/classes/image-normalizer')]).then(_ref => {
  let [moduleImageNormalizer] = _ref;
  // Define the components
  const ImageNormalizerController = moduleImageNormalizer.default;
  DomObserver.observe('.js-default-logo-grid.normalize-images', blocks => {
    blocks.forEach(block => {
      const ImageNormalizer = new ImageNormalizerController();
      const images = [...block.querySelectorAll('.js-default-logo-grid__image')];
      // Add the images to the ImageNormalizer
      ImageNormalizer.add(images);
    });
  });
}).catch(error => {
  console.error(error);
});